import React, { useMemo } from "react";
import { Progress } from "antd";
import { AlertOutlined, HourglassOutlined } from "@ant-design/icons";

export default function IntervalProgressHud({
  isMobile = false,
  remainingTimeSec = 0,
  elapsedTimeSec = 0,
  formatTime,
  style,
}) {
  const fmt = typeof formatTime === "function" ? formatTime : (s) => String(s);
  const rem = Math.max(0, Number(remainingTimeSec) || 0);
  const el = Math.max(0, Number(elapsedTimeSec) || 0);
  const total = rem + el;

  const pct = useMemo(() => {
    if (total <= 0) return 0;
    return Math.max(0, Math.min(100, Math.round((el * 100) / total)));
  }, [el, total]);

  const urgent = rem < 5;

  const pillStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    padding: isMobile ? "4px 8px" : "5px 10px",
    borderRadius: 999,
    fontSize: isMobile ? 12 : 12,
    fontWeight: 700,
    letterSpacing: 0.2,
    background: "rgba(255,255,255,0.70)",
    border: "1px solid rgba(0,0,0,0.10)",
    boxShadow: "0 6px 18px rgba(0,0,0,0.10)",
    color: urgent ? "rgba(207,19,34,1)" : "rgba(0,0,0,0.75)",
    whiteSpace: "nowrap",
  };

  return (
    <div
      style={{
        width: "100%",
        padding: isMobile ? "8px 10px" : "10px 12px",
        borderRadius: 14,
        border: "1px solid rgba(255,255,255,0.65)",
        background: "linear-gradient(135deg, rgba(255,255,255,0.75), rgba(235,245,255,0.60))",
        boxShadow: "0 10px 24px rgba(0,0,0,0.10), 0 0 22px rgba(24,144,255,0.10)",
        ...style,
      }}
    >
      <div style={{ display: "grid", gridTemplateColumns: "auto 1fr auto", gap: 10, alignItems: "center" }}>
        <div style={{ ...pillStyle, color: "rgba(0,0,0,0.65)" }}>{fmt(el)}</div>
        <div style={{ minWidth: 120 }}>
          <Progress
            percent={pct}
            showInfo={false}
            strokeColor={{
              "0%": urgent ? "#ff4d4f" : "#1677ff",
              "60%": urgent ? "#ff7875" : "#69c0ff",
              "100%": urgent ? "#ffd666" : "#b37feb",
            }}
            trailColor="rgba(0,0,0,0.06)"
            size={isMobile ? "small" : "default"}
            style={{ margin: 0 }}
          />
        </div>
        <div style={{ ...pillStyle, color: urgent ? "rgba(207,19,34,1)" : "rgba(22,119,255,1)" }}>
          {urgent ? <AlertOutlined /> : <HourglassOutlined />}
          {fmt(rem)}
        </div>
      </div>
    </div>
  );
}


